import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import StructurePreview from '@Components/Results/structure/StructurePreview';
import MarkushGroup from '@Components/Results/substances/tables/markush/MarkushGroup';
import StickyTableHeaderComponent from '@Components/Results/sticky-table-header.component';

import './MarkushDetails.scss';

const HEADERS = [
  { title: 'Label' },
  { title: 'Value' },
  { title: 'Size' },
  { title: 'Attributes' },
  { title: 'Substituted by' },
  { title: 'Frequency' },
];

function MarkushDetails({ data }) {
  const uid = useMemo(() => uniqueId('markush'), []);

  return (
    <div className="substance-results-markush">
      <div className="substances-item-wrapper">
        <StructurePreview markushPreview={data.path} />
      </div>
      <div className="clearfix scrollbar-container">
        <table className="rx-table sticky-table-header rx-table--quantitative">
          <StickyTableHeaderComponent headers={HEADERS} staticColumns />
          {Array.isArray(data.groups) &&
            data.groups?.map((group, idx) => <MarkushGroup key={group?.label || idx} uid={uid} group={group} />)}
        </table>
      </div>
    </div>
  );
}

MarkushDetails.propTypes = {
  data: PropTypes.object.isRequired,
};

export default MarkushDetails;
